import React from "react";
import {Layout} from 'antd';
import {renderRoutes} from "react-router-config";


import BaseComponent from "../../redare/components/BaseComponent";
import Header from "./components/Header";
import './index.scss';


export class IndexPage extends BaseComponent {

    state = {
        collapsed: false,
    };
    toggle = () => {
        this.setState({
            collapsed: !this.state.collapsed,
        });
    };

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Layout className="index-container">
                <Layout.Header className="index-header">
                    <Header/>
                </Layout.Header>
                <Layout.Content className="content-container">
                    {renderRoutes(this.props.route.routers)}
                </Layout.Content>
            </Layout>
        )
    }
}